import React from 'react'
import './DarkMode.css'

export default function Darkmode() {
    const SetDarkMode = () => {
        document.querySelector("body").setAttribute('data-theme', 'dark')
        document.querySelector("html").setAttribute('data-bs-theme', 'dark')
        localStorage.setItem("selectedTheme", "dark")
    }
    const SetLightMode = () => {
        document.querySelector("body").setAttribute('data-theme', 'light')
        document.querySelector("html").setAttribute('data-bs-theme', 'light')
        localStorage.setItem("selectedTheme", "light")
    }

    const SelectedTheme = localStorage.getItem("selectedTheme")
    if (SelectedTheme === "dark") {
        SetDarkMode()
    } else {
        SetLightMode();
    }

    const toggletheme = (e) => {
        if (e.target.checked) SetDarkMode()
        else SetLightMode()
    }

    return (
        <input type='checkbox' id="toggle" onChange={toggletheme} defaultChecked={SelectedTheme === "dark"} />
    )
}
